module.exports = __webpack_public_path__ + "media/components/country-flag/static/bt-ed0a35dcaabc32ec24453a8532c7f88f.svg";